import React from 'react';
import { Col, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import uniq from 'lodash/uniq';
import ArticleCard from './ArticleCard';
import { Article } from '../../../generated/graphql';
import AcceptDonations from './AcceptDonations';

interface Props {
  openArticleModal: (articleId: string) => void
  allArticleVariants: Article[][]
  hideImages?: boolean
}

const ArticlesList = ({
  openArticleModal, allArticleVariants, hideImages,
} : Props) => {
  const [translate] = useTranslation();

  const headings = uniq(allArticleVariants.map((v) => v[0]?.heading));

  return (
    <>
      <div className="my-4 articles-list-header">
        <h2 className="fw-bold text-center text-md-start">
          {translate('COMPONENTS.ARTICLES_LIST.HEADER')}
        </h2>
        <AcceptDonations />
      </div>
      {headings.map((heading) => (
        <React.Fragment key={heading || 'key'}>
          {!!heading && <h4 className="articles-list-header">{heading}</h4>}
          <Row>
            {allArticleVariants
              .filter((v) => v[0]?.heading === heading)
              .map((variants) => (
                <Col
                  key={variants[0]._id}
                  className="mb-6"
                  xs={12}
                  md={6}
                  lg={4}
                  xl={3}
                >
                  <ArticleCard variants={variants} openArticleModal={openArticleModal} hideImages={hideImages} />
                </Col>
              ))}
          </Row>
        </React.Fragment>
      ))}
    </>
  );
};

export default ArticlesList;
